import React from 'react';
import img2 from '../../assets/images/img2.webp';
import img5 from '../../assets/images/img5.webp';
import img6 from '../../assets/images/img6.webp';

import './gallery.css'


const Gallery = () => {
    const imageSrc = [
        { id: 2, imgSrc: img2},
        { id: 5, imgSrc: img5},
        { id: 6, imgSrc: img6},
    ]
  return (
    <section className='gallery__container'>
        <div className="gallery__content content__page">
            {imageSrc.map((photo, index) => {
                return (
                    <div className="photos" key={index}>
                        <img src={photo.imgSrc} alt="Porto de Aveiro 215 Anos - Open Days" />
                    </div>
                )
            })}
        </div>
    </section>
  )
}

export default Gallery;